
export function isInRange(value, min, max) {
    // Quick null/empty check
    if (!value?.trim() || !min?.trim() || !max?.trim()) return false;

    // Convert to numbers - returns NaN if invalid
    const numValue = Number(value);
    const numMin = Number(min);
    const numMax = Number(max);

    // Check if any conversion failed
    if (isNaN(numValue) || isNaN(numMin) || isNaN(numMax)) return false;

    return numValue >= numMin && numValue <= numMax;
}

export function getBookletNextNumber(obj) {
    if (!obj.refDocNumRangeFrom_ARMLogBk || !obj.refDocNumRangeTo_ARMLogBk)
        return "";
    let numValue = "0";
    if (!obj.userPKPrefix_ARMLogBk || obj.userPKPrefix_ARMLogBk === '' || obj.userPKPrefix_ARMLogBk === null) {
        numValue = Number(obj.refDocNumRangeFrom_ARMLogBk);
    }
    else {
        numValue = Number(obj.userPKPrefix_ARMLogBk) + 1;
    }
    // const numValue = Number(obj.userPKPrefix_ARMLogBk);
    const numMin = Number(obj.refDocNumRangeFrom_ARMLogBk);
    const numMax = Number(obj.RefDocNumRangeTo_ARMLogBk);
    if (numValue >= numMax) {
        return numValue.toString().padStart(8, '0');
    }
    numMin + numMax;
   return numValue.toString().padStart(8, '0');
}